import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "zap",
  "use": "zap-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"zap\">\n    <g id=\"zap_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <g id=\"zap_zap\" transform=\"translate(4.000000, 3.000000)\" stroke=\"currentColor\">\n            <polygon id=\"zap_Shape\" points=\"8.88888889 0 0 10.6666667 8 10.6666667 7.11111111 17.7777778 16 7.11111111 8 7.11111111\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol